import phoneCodesData from '@/lib/data/phone-codes.json';
import { useState } from 'react';

export interface Country {
  name: string;
  code: string;
  emoji: string;
  image: string;
  dialCodes?: string[];
  slug: string;
  pattern?: string;
  formatMask?: string;
}

export function usePhoneValidator() {
  const countries = phoneCodesData;
  const [isValid, setIsValid] = useState(true);
  const [error, setError] = useState('');
  const [selectedCountry, setSelectedCountry] = useState<Country>(
    countries.find((c) => c.code === 'CL') || countries[0],
  );

  const validatePhone = (phone: string, country: Country = selectedCountry) => {
    if (!phone) {
      setIsValid(true);
      setError('');
      return true;
    }

    const cleanPhone = phone.replace(/\D/g, '');

    if (!country.pattern) {
      const valid = cleanPhone.length >= 7 && cleanPhone.length <= 15;
      setIsValid(valid);
      setError(valid ? '' : 'Formato inválido de teléfono');
      return valid;
    }

    const regex = new RegExp(country.pattern);
    const valid = regex.test(cleanPhone);
    setIsValid(valid);
    setError(valid ? '' : 'Formato inválido de teléfono');

    return valid;
  };

  const formatPhone = (phone: string, country: Country = selectedCountry) => {
    const cleanPhone = phone.replace(/\D/g, '');

    if (!country.formatMask) {
      return cleanPhone;
    }

    let formatted = '';
    let phoneIndex = 0;

    for (let i = 0; i < country.formatMask.length && phoneIndex < cleanPhone.length; i++) {
      const maskChar = country.formatMask[i];

      if (maskChar === '#') {
        formatted += cleanPhone[phoneIndex];
        phoneIndex++;
      } else {
        formatted += maskChar;
      }
    }

    return formatted;
  };

  const getCountryByCode = (code: string): Country | undefined => {
    return countries.find((country) => country.code === code);
  };

  const getCountriesByDialCode = (dialCode: string): Country[] => {
    return countries.filter((country) => country.dialCodes?.some((dc) => dc === dialCode));
  };

  return {
    isValid,
    error,
    selectedCountry,
    setSelectedCountry,
    validatePhone,
    formatPhone,
    countries,
    getCountryByCode,
    getCountriesByDialCode,
  };
}
